export default (function (_ref) {
  var streetAddr1 = _ref.streetAddr1,
    street1 = _ref.street1,
    streetAddr2 = _ref.streetAddr2,
    street2 = _ref.street2,
    streetAddr3 = _ref.streetAddr3,
    street3 = _ref.street3,
    city = _ref.city,
    state = _ref.state,
    stateCode = _ref.stateCode,
    zip5 = _ref.zip5,
    postalCode = _ref.postalCode,
    internationalPostalCode = _ref.internationalPostalCode,
    province = _ref.province,
    countryCode = _ref.countryCode,
    country = _ref.country,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles;
  var isInternational = countryCode && countryCode !== 'US' || country && country !== 'US';
  var stateOrProvince = state || stateCode || province;
  return /*#__PURE__*/React.createElement("address", {
    style: styles
  }, streetAddr1 ? /*#__PURE__*/React.createElement("div", null, streetAddr1) : null, streetAddr2 ? /*#__PURE__*/React.createElement("div", null, streetAddr2) : null, streetAddr3 ? /*#__PURE__*/React.createElement("div", null, streetAddr3) : null, street1 ? /*#__PURE__*/React.createElement("div", null, street1) : null, street2 ? /*#__PURE__*/React.createElement("div", null, street2) : null, street3 ? /*#__PURE__*/React.createElement("div", null, street3) : null, /*#__PURE__*/React.createElement("div", null, city, city && stateOrProvince ? ', ' : null, " ", stateOrProvince, " ", zip5 || postalCode || internationalPostalCode), isInternational ? /*#__PURE__*/React.createElement("div", null, countryCode || country) : null);
});